// The physical media a tag/label number can be printed on. The NUMBER is independent
// of media — the same number prints on any of these. This is the SINGLE source of
// truth: the shared <MediaPicker> renders from here, so adding a media (or changing a
// label) lands ONCE and appears in every picker automatically.
export const TAG_MEDIA = [
  { code: "hang_tag", label: "Hang tag 4×6", size: "4x6" },
  { code: "sticker", label: "Sticker 4×3", size: "4x3" },
  { code: "barcode_label", label: "Barcode 3×1", size: "3x1" },
];

export const mediaLabelOf = (code) =>
  (TAG_MEDIA.find((m) => m.code === code) || {}).label || code;

// Media a tech could switch TO from the current one (the "wrong media" fix targets).
export const otherMedia = (current) => TAG_MEDIA.filter((m) => m.code !== current);

// Media <-> backend physical size string ("4x6"/"4x3"/"3x1"). Container/location
// label endpoints speak `size`; part/donor tag endpoints speak `media`. One mapping
// so a size never has to be re-derived with a scattered ternary.
export const mediaToSize = (code) => (TAG_MEDIA.find((m) => m.code === code) || {}).size || "4x3";
export const sizeToMedia = (size) => (TAG_MEDIA.find((m) => m.size === size) || {}).code || "sticker";
